export default __webpack_public_path__ + "static/sac.mobile.inspirations-a9e6be43eb3f0a291e3da34967bf56fa.jpg";